import React, {useEffect} from 'react';

import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import { useStoreActions, useStoreState } from "easy-peasy";


export default function Accounts() {
  const accounts = useStoreState(state => state.account.accounts);
  const account_id = useStoreState(state => state.account_id);
  const is_logged_in = useStoreState(state => state.is_logged_in);
  const getAccounts = useStoreActions(actions => actions.account.getAccounts);
  const changeAccount = useStoreActions(actions => actions.changeAccount);
  const unchangeAccount = useStoreActions(actions => actions.unchangeAccount);

  useEffect(() => {
    if (is_logged_in) {
      getAccounts();
    }
  }, [getAccounts, is_logged_in, account_id]);

  const use_account = async (account_id) => {
    await changeAccount(account_id);
  }

  const unuse_account = async () => {
    await unchangeAccount();
  }

  return (
    <div className="container px-0">
      <div className="row">
        <div className="col-12">
          <h3>Accounts</h3>
          <div>
          {account_id !== 0 && (
              <h5>Currently set to account {account_id}, <p><Button onClick={unuse_account}>Back to my account</Button></p></h5>
          )}
          </div>
          <Table striped bordered responsive>
            <thead>
              <tr>
                <th>&nbsp;</th><th>Account Name</th><th>Account ID</th><th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
            {accounts.map(account => (
              <tr key={account.id}>
                <td>
                {account_id === account.id && (
                  <strong>*</strong>
                )}
                </td>
                  <td>{account.name}</td><td>{account.id}</td><td><Button onClick={() => use_account(account.id)} variant="primary">Use</Button></td>
              </tr>
            ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
